import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { qrRedirectQueryKeys } from "./queryKeys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import {
  QRRedirectCreate,
  QRRedirectUpdate,
} from "../../models/qrRedirect/QRRedirect";
import useUserContext from "../../contexts/UserContext";

export function useQRRedirectMutations() {
  const {
    user: { agency },
  } = useUserContext();
  const queryClient = useQueryClient();
  const { del, put, post } = useApiHelper();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("Redirect");

  const create = useMutation(
    (redirect: QRRedirectCreate) =>
      post(`/redirect/${agency.id}/manage`, redirect),
    {
      ...saveHandlers,
      onSuccess: () => {
        queryClient.invalidateQueries(qrRedirectQueryKeys._base());
        saveHandlers.onSuccess?.();
      },
    }
  );

  const update = useMutation(
    (redirect: QRRedirectUpdate) =>
      put(`/redirect/${agency.id}/manage/${redirect.id}`, redirect),
    {
      ...saveHandlers,
      onSuccess: () => {
        queryClient.invalidateQueries(qrRedirectQueryKeys._base());
        saveHandlers.onSuccess?.();
      },
    }
  );

  const remove = useMutation(
    (redirectId: string) => del(`/redirect/${agency.id}/manage/${redirectId}`),
    {
      ...deleteHandlers,
      onSuccess: () => {
        queryClient.invalidateQueries(qrRedirectQueryKeys._base());
        deleteHandlers.onSuccess?.();
      },
    }
  );

  return {
    create,
    update,
    remove,
  };
}
